import { Helmet } from "react-helmet";
import DashboardLayout from "@/components/layouts/DashboardLayout";

const Business = () => {
  return (
    <DashboardLayout>
      <Helmet>
        <title>Business Details - Numberz Insight</title>
        <meta name="description" content="Manage your business information and registration details." />
      </Helmet>

      <div className="max-w-4xl mx-auto">
        <h1 className="text-2xl font-semibold mb-6">Business Details</h1>
        <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-lg">
          <p className="text-gray-600 dark:text-gray-300">Business management features coming soon.</p>
        </div>
      </div>
    </DashboardLayout>
  );
};

export default Business;